import { useTranslation } from 'react-i18next';

import { ReactComponent as DownloadIcon } from '../../../../../assets/icons/icon-download.svg';
import { TRANSLATIONS_QUOTES } from '../../../../translations/quotes';
import CustomButton from '../../../Buttons/CustomButton/CustomButton';
import BannerFill from '../../../Globals/BannerFill/BannerFill';

import './CensusErrorFormatStep.scss';

export interface CensusErrorFormatStepProps {
  onDownloadTemplate: () => Promise<void>;
}

export default function CensusErrorFormatStep({ onDownloadTemplate }: Readonly<CensusErrorFormatStepProps>) {
  const { t } = useTranslation();

  return (
    <div className="census-step census-error-format-step">
      <BannerFill
        variant="danger"
        title={t(TRANSLATIONS_QUOTES.create.censusModal.errorFormatTitle)}
        description={t(TRANSLATIONS_QUOTES.create.censusModal.errorFormatDesc)}
        icon={'✕ '}
      />

      <div className="census-error-format-step__actions">
        <CustomButton variant="default" size="xs" onClick={onDownloadTemplate}>
          <DownloadIcon />
          {t(TRANSLATIONS_QUOTES.create.censusModal.downloadTemplate)}
        </CustomButton>
      </div>
    </div>
  );
}
